import React from 'react';
import classes from './Alert.css';

const Alert = ({
    textMessage, 
    Icon, 
    iconColor, 
    iconFontSize,
    buttonText,
    buttonCallBack,
    id,
    buttonId,
    txtId,
    AlertIcon
}) => {
    return (
            <div className={classes.alertDailog} id = {id}>
                <div className={classes.leftAlertDailog}>
                    {Icon && <Icon
                        color={iconColor}
                        fontSize={iconFontSize}
                        style={{ marginRight: '10px' }}
                        id = { AlertIcon ? AlertIcon : ''}
                    />}
                    <span  id = {txtId ? txtId : '' } className={classes.alertMessage}>
                    {textMessage}
                    </span>
                </div>
                {buttonText && <div className={classes.rightAlertDailog}>
                    <button
                        id={ buttonId ? buttonId : ''}
                        className={classes.RegularButton}
                        onClick={buttonCallBack}
                    >
                    {buttonText}
                    </button>
                    </div>}
                
            </div>
    )
}

export default Alert;
